<template>
  <ValidationObserver class="d-flex flex-column h-100" v-slot="{handleSubmit, validation, errors}" ref="observer"
                      tag="div">
    <b-form @submit.prevent="handleSubmit(onSubmit)" class="d-flex h-100">
      <SidebarLayout :title="$t('Main Fields')">
        <template v-slot:sidebar>
          <Spinner :show="mainFields.loading"/>
          <ul v-if="!mainFields.loading && mainFields.rows.length" class="nav flex-column">
            <li v-for="(mainField) in mainFields.rows"
                :key="mainField.key"
                :class="{ 'active': selectedMainField && mainField.key === selectedMainField.key }"
                @click="changeMainField(mainField)"
                class="nav-item">
              <a class="nav-link">
                {{ mainField.label }}
              </a>
            </li>
          </ul>
          <no-data-available v-if="!mainFields.loading && !mainFields.rows.length" height="10"/>
        </template>
        <template v-slot:content>
          <div class="bg-white p-2 ">
            <Spinner :show="mainFields.loading"/>
            <template v-if="!mainFields.loading">
              <div v-if="selectedMainField">
                <div class="table-component content-wrapper">
                  <artisio-table ref="dependedFieldTable" :pagination="dependedFields.pagination"
                                 :sort="dependedFields.ordering" :items="dependedFields.rows"
                                 :busy="dependedFields.loading" scrollable filter-toggle-string="depended-field-table"
                                 :checkboxes="true" :fields="tableFields" :enable-simple-search="false"
                                 @paramsChanged="loadDependedFields">

                    <template v-slot:search-form-placeholder>
                      <search-collapse table-id="depended-field-table">
                        <depended-field-search/>
                      </search-collapse>
                    </template>

                    <template v-slot:header-buttons="{selectedItems}">
                      <add-new-button @click.prevent="onAddClick">
                        <font-awesome-icon icon="plus-circle" class="icon"/>
                        {{ $t('New') }} {{ selectedMainField.label }}
                      </add-new-button>
                    </template>

                    <template slot="cell(key)" slot-scope="{item: dependedField}" class="text-center">
                      {{ dependedField.key }}
                      <action-buttons
                        :view="false"
                        :edit="true"
                        :remove="true"
                        @deleteClick="onRemoveClick(dependedField)"
                        @editClick="onEditClick(dependedField)"/>
                    </template>
                    <template :slot="`cell(${selectedMainField.key})`" slot-scope="{item: dependedField}"
                              class="text-center">
                      <span>{{ $options.filters.masterLanguage(dependedField.data)[selectedMainField.key] }}</span>
                    </template>
                    <template :slot="`cell(${dynamicField})`" slot-scope="{item: dependedField}"
                              v-for="dynamicField in selectedMainField.depended_fields">
                    <span :key="dynamicField"
                          v-html="$options.filters.asDynamicField($options.filters.masterLanguage(dependedField.data)[dynamicField], selectedMainField.config[dynamicField].type, selectedMainField.config[dynamicField].choices)"></span>
                    </template>
                  </artisio-table>
                </div>
              </div>
              <no-data-available v-if="!selectedMainField" height="10"/>
            </template>
          </div>
        </template>
      </SidebarLayout>
    </b-form>
    <depended-field-modal/>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import Spinner from "../../../core/components/common/Spinner";
  import AddNewButton from "../../../core/components/common/AddNewButton";
  import DependedFieldModal from "./DependedFieldModal";
  import SidebarLayout from "../../../core/components/layout/DefaultLayout/SidebarLayout";
  import NoDataAvailable from "@/core/components/common/NoDataAvailable";
  import ArtisioTable from "../../../core/components/ams-table/ArtisioTable.vue";
  import ActionButtons from "../../../core/components/ams-table/ActionButtons.vue";
  import DependedFieldSearch from "@/modules/setup/depended-fields/DependedFieldSearch";
  import SearchCollapse from "@/core/components/search-collapse/SearchCollapse";

  const {mapState, mapActions, mapGetters} = createNamespacedHelpers('setup/dependedField');

  export default {
    name: "DependedFields",
    components: {
      SearchCollapse,
      DependedFieldSearch,
      ActionButtons,
      ArtisioTable,
      NoDataAvailable,
      SidebarLayout, AddNewButton, Spinner, DependedFieldModal
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['mainFields', 'selectedMainField', 'dependedFields']),
      ...mapGetters({tableFields: 'tableFields'}),
    },
    methods: {
      ...mapActions(['showModal', 'getMainFields', 'selectMainField', 'loadDependedFields', 'removeDependedField']),
      async changeMainField(mainField) {
        this.selectMainField(mainField);
      },
      onAddClick() {
        this.showModal(null);
      },
      onEditClick(dependedField) {
        this.showModal(dependedField);
      },
      onRemoveClick(dependedField) {
        this.$confirm(
            this.$i18n.t("Are you sure you want to delete following record?"),
            this.$i18n.t('Record was successfully deleted'),
            this.removeDependedField,
            dependedField
        );
      }
    },
    async beforeMount() {
      await this.getMainFields();
      if (this.$route.params.main_field_key) {
        this.changeMainField(this.mainFields.rows.find(mField => mField.key === this.$route.params.main_field_key))
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "./../../../scss/index";

  .title {
    display: inline-flex;
    flex: 1;
    align-items: center;
  }
  .depended-fields-wrapper {
    overflow-y: auto;
  }

  .content-wrapper {
    height: calc(100vh - 17em);
  }

</style>
